import { apiClient } from '../client'

class RealogramRepository {
  /**
   * Get photos data for a store
   */
  async getStorePhotos(storeId: number): Promise<any> {
    return apiClient.get<any>(`/realogram/store/${storeId}/photos`)
  }
}

export const realogramRepository = new RealogramRepository()
